import { Button } from "@buildpy/ui/button";
import SectionCard from "@buildpy/ui/section-card";
import { logout } from "@/api/actions/org";
import { BrandLogo } from "@buildpy/ui/brand-logo";
import OnboardingWizard from "@/modules/onboarding/ui/onboarding-wizard";

// 시공사 만들기 — 메일 확인·비밀번호 정하기를 마쳤지만 소속 시공사가 없는 계정만 온다(route beforeLoad 가 가른다) · 다른 계정으로 바꾸려면 로그아웃.
const OnboardingPage = ({ userId }: { userId: string }) => (
  <main className="safe-top-fill flex min-h-screen items-start justify-center bg-background px-4 pb-4 pt-safe-4 sm:items-center">
    <SectionCard as="div" className="flex w-full max-w-xl flex-col gap-y-6" data-testid="onboarding-page" padding="lg">
      <div className="flex items-center justify-between gap-x-3">
        <h2 className="flex">
          <BrandLogo size="lg" />
        </h2>
        <form
          action={async () => {
            await logout();
          }}>
          <Button data-testid="onboarding-logout" size="inline" type="submit" variant="link-muted">
            로그아웃
          </Button>
        </form>
      </div>
      <OnboardingWizard userId={userId} />
    </SectionCard>
  </main>
);

export default OnboardingPage;
